import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="text-toggle"
export default class extends Controller {
  static targets = ["truncated", "full", "moreButton", "lessButton"];

  connect() {
    // Initially hide the full text and show less button
    this.fullTarget.classList.add("d-none");
    this.lessButtonTarget.classList.add("d-none");

    // Only show the 'more' button if the text was actually truncated
    // This assumes the server rendered both spans even if not truncated.
    // If the 'moreButton' target doesn't exist (because the server didn't render it),
    // hasMoreButtonTarget will be false and no error will occur.
    if (
      this.hasMoreButtonTarget &&
      this.truncatedTarget.textContent.length ===
        this.fullTarget.textContent.length
    ) {
      this.moreButtonTarget.classList.add("d-none");
    }
  }

  showMore(event) {
    event.preventDefault();
    this.truncatedTarget.classList.add("d-none");
    if (this.hasMoreButtonTarget) this.moreButtonTarget.classList.add("d-none");
    this.fullTarget.classList.remove("d-none");
    this.lessButtonTarget.classList.remove("d-none");
  }

  showLess(event) {
    event.preventDefault();
    this.fullTarget.classList.add("d-none");
    this.lessButtonTarget.classList.add("d-none");
    this.truncatedTarget.classList.remove("d-none");
    if (this.hasMoreButtonTarget)
      this.moreButtonTarget.classList.remove("d-none");
  }
}
